module.exports = __webpack_public_path__ + "img/0003.973954e0.jpg";